// ParticleBackground.js
import React, { useRef, useEffect, useState } from 'react';
import { Canvas, useFrame } from '@react-three/fiber';
import * as THREE from 'three';



/**
 * فحص بسيط إذا المتصفح يدعم WebGL
 * يعيد false لو SSR أو لو لم نستطع الحصول على context
 */
function isWebGLAvailable() {
    if (typeof window === 'undefined') return false; // SSR safety
    try {
        const canvas = document.createElement('canvas');
        const gl = canvas.getContext('webgl') || canvas.getContext('experimental-webgl');
        // إزالة المرجع لضمان تنظيف
        canvas.remove();
        return !!(gl && gl instanceof WebGLRenderingContext);
    } catch (e) {
        return false;
    }
}
/** ErrorBoundary حتى نلتقط أي خطأ أثناء رندر الـ Canvas */
class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }
    static getDerivedStateFromError() {
        return { hasError: true };
    }
    componentDidCatch(error, info) {
        // لو حبيت ترسل الخطأ لخدمة تتبع أخطاء حطها هنا
        // console.error('ParticleBackground error:', error, info);
    }
    render() {
        if (this.state.hasError) return null; // نوقف الإظهار لو صار خطأ
        return this.props.children;
    }
}
const Particles = () => {
    const particlesRef = useRef();

    useEffect(() => {
        const particleCount = 1500;
        const positions = new Float32Array(particleCount * 3);

        for (let i = 0; i < particleCount; i++) {
            const x = (Math.random() - 0.5) * 15;
            const y = (Math.random() - 0.5) * 15;
            const z = (Math.random() - 0.5) * 15;

            positions[i * 3] = x;
            positions[i * 3 + 1] = y;
            positions[i * 3 + 2] = z;
        }
        if (particlesRef.current?.geometry) {
            particlesRef.current.geometry.setAttribute('position', new THREE.BufferAttribute(positions, 3));
        }
        // particlesRef.current.geometry.setAttribute('position', new THREE.BufferAttribute(positions, 3));
    }, []);

    useFrame(({ clock }) => {
        const elapsedTime = clock.getElapsedTime();
        // particlesRef.current.rotation.y = elapsedTime * 0.1;
        if (particlesRef.current) {
            particlesRef.current.rotation.y = elapsedTime * 0.1;
        }
    });

    return (
        <points ref={particlesRef}>
            <bufferGeometry attach="geometry" />
            <pointsMaterial attach="material" color="white" size={0.01} />
        </points>
    );
};

const ParticleBackground = ({ particleCount = 1500, style = {} }) => {
    const [webglSupported, setWebglSupported] = useState(false);

    useEffect(() => {
        setWebglSupported(isWebGLAvailable());
    }, []);

    // لو WebGL مش متاح نرجع null (أو ممكن ترجع عنصر بديل CSS)
    if (!webglSupported) {
        return null; // أو: return <div className="particle-fallback" /> لتعرض خلفية بسيطة
    }
    return (
        // <Canvas className="particle-canvas" style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}>
        //     <Particles />
        // </Canvas>
        <ErrorBoundary>
            <Canvas
                className="particle-canvas"
                style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    pointerEvents: 'none', // عشان لا تأثر على تفاعلات الواجهة
                    zIndex: 0,
                    ...style,
                }}
                // يمكنك ضبط dpr أو pixelRatio لو عايز تقلل الضغط على الأجهزة القديمة:
                gl={{ powerPreference: 'low-power', antialias: false }}
            >
                <ambientLight intensity={0.5} />
                <Particles particleCount={particleCount} />
            </Canvas>
        </ErrorBoundary>
    );
};

export default ParticleBackground;
